import { render, staticRenderFns } from "./Vidello.vue?vue&type=template&id=c50ada6c&scoped=true&"
import script from "./Vidello.vue?vue&type=script&lang=js&"
export * from "./Vidello.vue?vue&type=script&lang=js&"
import style0 from "./Vidello.vue?vue&type=style&index=0&id=c50ada6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50ada6c",
  null
  
)

export default component.exports